module.exports = __webpack_public_path__ + "img/btn_pg_alipay.69b498a6.png";